/**
 * Sanitize a redirect target so a phishing link can't bounce the user
 * to an external origin after sign-in.
 *
 * Returns the input only if it's a same-origin path:
 *   - must be a string starting with "/"
 *   - must not start with "//" or "/\" (protocol-relative)
 *   - must not contain a scheme (anything before "://")
 *   - must not contain control characters or whitespace
 *
 * Anything else falls back to `fallback`.
 */
export function safeInternalRedirect(input: unknown, fallback: string): string {
  if (typeof input !== "string" || input.length === 0) return fallback
  if (input.length > 512) return fallback

  if (!input.startsWith("/")) return fallback
  if (input.startsWith("//") || input.startsWith("/\\")) return fallback

  // Reject control chars / whitespace / encoded backslash that could be
  // re-decoded by a downstream router.
  if (/[\s\x00-\x1f\x7f]/.test(input)) return fallback
  if (/%5c/i.test(input) || /%2f%2f/i.test(input)) return fallback

  return input
}
